import { z } from "zod";

// kill-hasura: notificaciones por REST (GET /api/v1/notifications). El BFF
// devuelve el mismo shape que el getNotifications de Hasura
// (messaging_user_notifications), con la relacion `notification` anidada:
// { id, businessId, createdAt, notificationId, status, userId,
//   notification: { id, businessId, createdAt, level, payload, title, type,
//                   userId, warehouseId } }.
// Schema permisivo passthrough que conserva todos los scalars + el objeto
// `notification` anidado sin stripear.
export const notificationSchema = z.object({ id: z.string() }).passthrough();

export type NotificationDTO = z.infer<typeof notificationSchema>;

// kill-hasura: counts de notificaciones por REST (GET /api/v1/notifications/counts).
// El BFF devuelve { all, read, unread } directo (NO el envelope { data, total }),
// reemplazando los 3 aggregates de Hasura (all / read / unread) del
// useGetNotificationCounts viejo. El BFF deriva business + user del JWT.
export const notificationCountsSchema = z.object({
  all: z.number(),
  read: z.number(),
  unread: z.number(),
});

export type NotificationCountsDTO = z.infer<typeof notificationCountsSchema>;
